'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pathToRegexp = require('path-to-regexp');

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var normalize = function normalize(path) {
    path = path || '';

    if (path[0] === '/') {
        path = path.substring(1);
    }

    return '/' + path;
};

exports.default = function (pattern) {
    pattern = normalize(pattern);

    var keys = [];
    var regex = (0, _pathToRegexp2.default)(pattern, keys);
    var paramNames = keys.map(function (key) {
        return key.name;
    });

    return function (pathname) {
        pathname = normalize(pathname);
        var match = regex.exec(pathname);

        if (!match) {
            return false;
        } else {
            var result = {};

            match.splice(1).forEach(function (paramValue, index) {
                result[paramNames[index]] = paramValue;
            });

            return result;
        }
    };
};
//# sourceMappingURL=route-parser.js.map